
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { notificationsReducer } from './reducer';
import { NotificationsStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, notificationsReducer),
		EffectsModule.forFeature([NotificationsStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class NotificationsStoreModule { }
